export const MAX_MOBILE_WIDTH = 767;
export const SOURCES_PAGE_SIZE = 20;
